import { z } from "zod";

export const folderGeneratorSchema = () => {
  return z.object({
    image: z.any().refine((file) => file instanceof File, {
      message: "Selecione uma imagem para o folder.",
    }),
    agreement_ids: z.array(z.number()).optional(),
  });
};

export type FolderGeneratorFormValues = z.infer<ReturnType<typeof folderGeneratorSchema>>;
